module.exports = __webpack_public_path__ + "static/mashup-garage-e74c28ff108f1758eec48e23beb0e779.jpg";